import { defineMessage } from 'services/localization';

export const messages = {
    onReviewBadgeText: defineMessage('on_review_1'),
    approvedBadgeText: defineMessage('approved'),
    paidBadgeText: defineMessage('paid'),
    cancelledBadgeText: defineMessage('cancelled'),
    rejectedBadgeText: defineMessage('rejected'),
    pendingPushTitle: defineMessage('waiting_to_be_synced_to_integrationname'),
    acceptedBadgeText: defineMessage('accepted'),
    declinedBadgeText: defineMessage('declined'),
    awaitingPaymentBadgeText: defineMessage('awaiting_payment'),
    processingBadgeText: defineMessage('processing'),
    partiallyPaidBadgeText: defineMessage('partially_paid'),
    failedBadgeText: defineMessage('failed'),
    inProgressBadgeText: defineMessage('in_progress'),
    paidInFullBadgeText: defineMessage('paid_in_full_1'),
};
